import VueRouter from 'vue-router';
import store from './store';
import VueBodyClass from 'vue-body-class';
import Vue from 'vue';
import VueYandexMetrika from 'vue-yandex-metrika';

import Index from '@/pages/Index';
import Promo from '@/pages/Promo';
import PromoTraining from '@/pages/PromoTraining';
import Trainings from '@/pages/Trainings';
import Training from '@/pages/Training';
import Articles from '@/pages/Articles';
import Article from '@/pages/Article';
import Plans from '@/pages/Plans';
import Plan from '@/pages/Plan';
import Consultations from '@/pages/Consultations';
import Policy from '@/pages/Policy';
import About from '@/pages/About';
import Profile from '@/pages/Profile';
import Login from '@/pages/Login';
import PasswordChange from '@/pages/PasswordChange';
import EmailChange from '@/pages/EmailChange';
import EmailGo from '@/pages/EmailGo';
import Payment from '@/pages/Payment';
import Feedback from '@/pages/Feedback';
import TrainingFeedback from '@/pages/TrainingFeedback';
import Contacts from '@/pages/Contacts';
import request from '@/api/axios';

import Test from '@/pages/Test';

const routes = [
  {
    path: '/',
    component: Index,
    name: 'index',
    meta: { bodyClass: 'body-index' },
  },
  {
    path: '/promo',
    component: Promo,
    name: 'promo',
    meta: {
      layout: 'promo'
    }
  },
  {
    path: '/promo-training',
    component: PromoTraining,
    name: 'promo-training',
    meta: {
      layout: 'promo'
    }
  },
  {
    path: '/trainings',
    component: Trainings,
    name: 'trainings',
    meta: {
      // requiresAuth: true,
      // needSubscription: true, // todo remove comment later
      layout: 'promo'
    }
  },
  {
    path: '/trainings/:id',
    component: Training,
    name: 'training',
    meta: {
      // тренировки доступны всем: без авторизации и без подписки
      // layout: 'promo'
    }
  },
  {
    path: '/articles',
    component: Articles,
    name: 'articles'
  },
  {
    path: '/articles/:code',
    component: Article,
    name: 'article'
  },
  {
    path: '/plan',
    component: Plans,
    name: 'plans',
    meta: {
      layout: 'promo'
    }
  },
  {
    path: '/plan/:id',
    component: Plan,
    name: 'plan',
    meta: {
      testGuard: true // todo rename testGuard
      // requiresAuth: true,
      // needSubscription: true
    }
  },
  {
    path: '/consultations',
    component: Consultations,
    name: 'consultations'
  },
  {
    path: '/policy',
    component: Policy,
    name: 'policy'
  },
  {
    path: '/about',
    component: About,
    name: 'about'
  },
  {
    path: '/profile',
    component: Profile,
    name: 'profile',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    component: Login,
    name: 'login',
    meta: {
      guest: true,
      layout: 'promo'
    }
  },
  {
    path: '/profile/password-change',
    component: PasswordChange,
    name: 'password-change',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/profile/email-change',
    component: EmailChange,
    name: 'email-change',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/profile/email-go',
    component: EmailGo,
    name: 'email-go',
  },
  {
    path: '/mail',
    component: Login,
    name: 'mail',
    meta: {
      mail: true
    }
  },
  {
    path: '/profile/payment',
    component: Payment,
    name: 'payment',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/feedback',
    component: Feedback,
    name: 'feedback'
  },
  {
    path: '/training-feedback',
    component: TrainingFeedback,
    name: 'training-feedback'
  },
  {
    path: '/contacts',
    component: Contacts,
    name: 'contacts'
  },
  {
    path: '/test',
    component: Test,
    name: 'test'
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior() {
    return {x: 0, y: 0}
  }
});

Vue.use(VueYandexMetrika, {
  id: 57080467,
  router: router,
  env: process.env.NODE_ENV
});

const vueBodyClass = new VueBodyClass(routes);

// Функция для авторизации по токену
const tryTokenAuth = async (token, login) => {
  try {
    const response = await request({
      action: 'login_raw',
      options: {
        phone: login,
        token
      }
    });

    if (response.data.status === true) {
      store.commit('login', response.data.user);
      return true;
    }
    return false;
  } catch (error) {
    console.error('Token auth error:', error);
    return false;
  }
};

router.beforeEach(async (to, from, next) => {
  vueBodyClass.guard(to, next);

  // todo rename testGuard
  if (to.matched.some(record => record.meta.testGuard)) {
    if (store.state.user === null || !store.state.user?.subscription?.active) {
      const queryParams = { backUrl: to.fullPath }
      if (store.state.user?.phone?.original) {
        queryParams.activateTele2 = '1';
        queryParams.phone = store.state.user.phone.original;
      }
      next({
        path: '/promo',
        query: queryParams
      });
    }
  } else {
    if (to.matched.some(record => record.meta.requiresAuth)) {
      if (store.state.user === null) {

        // Проверяем наличие GET-параметров token и login
        const token = to.query.token;
        const login = to.query.login;

        if (token && login) {
          // Пытаемся авторизовать пользователя по токену
          const authSuccess = await tryTokenAuth(token, login);
          console.log('authSuccess', authSuccess);

          // Создаем новый объект query без token и login
          const newQuery = { ...to.query };
          delete newQuery.token;
          delete newQuery.login;

          if (authSuccess) {
            // При успешной авторизации остаемся на текущей странице, но без параметров
            next({
              path: to.path,
              query: newQuery,
              hash: to.hash
            });
          } else {
            // При неудачной авторизации переходим на login
            next({
              path: '/login',
              query: {backUrl: to.fullPath}
            });
          }
        } else {
          next({
            path: '/login',
            query: {backUrl: to.fullPath}
          });
        }
      } else {
        if (to.matched.some(record => record.meta.needSubscription)) {
          if (store.state.user?.subscription?.active) {
            next();
          } else {
            next({
              path: '/profile/payment',
              query: {backUrl: to.fullPath}
            });
          }
        }

        next();
      }
    } else if (to.matched.some(record => record.meta.guest)) {
      if (store.state.user === null) {
        next();
      } else {
        next({path: '/'});
      }
    } else {
      next();
    }
  }
});

export default router;
